module.exports = __webpack_public_path__ + "img/herbie53.png";